(function ($) {
    Drupal.behaviors.contentBlockAddToBagV1 = {
      attached: false,
      attach: function (context) {
        if (this.attached) {
          return;
        }
        this.attached = true;
        this.addToBagHandler(context);
      },
  
      addToBagHandler: function(context) {
        var $addToBagWrappers = $('.js-content-block__add-to-bag-wrapper', context);
  
        $addToBagWrappers.each(function() {
          var $addToBagWrapper = $(this);
          var $addToBag = $addToBagWrapper.find('.js-content-block__add-to-bag-button .js-elc-button');
          var $selectedProducts = $addToBagWrapper.find('.js-content-block__add-to-bag-item');
          var addToBagText = $addToBagWrapper.find('.js-content-block__add-to-bag-button span').text();
          var addedToCartText = $addToBag.closest('.js-content-block__add-to-bag-button').attr('data-added-text');
    
          $addToBag.once().on('click', function (e) {
            e.preventDefault();
            $(this).find('span').text(addedToCartText);
            var selectedSkuIds = [];
    
            $selectedProducts.each(function () {
              var $selectedProduct = $(this);
              selectedSkuIds.push($selectedProduct.attr('data-sku-base-id'));
            });
    
            if (selectedSkuIds.length > 0) {
              var params = {
                skus: selectedSkuIds,
                itemType: 'cart',
                INCREMENT: 1,
                CAT_BASE_ID: '',
                QTY: 1
              };
    
              generic.checkout.cart.updateCart({
                params: params,
                onSuccess: function (response) {
                  $addToBag.find('span').text(addToBagText);
                  var messages = response.getMessages();
                  var offerCriteriaMessages = '';
    
                  if (messages) {
                    messages.forEach(function (message) {
                      if (message.key === 'offer_criteria_not_met') {
                        offerCriteriaMessages = offerCriteriaMessages.concat(message.text + '<br />');
                      }
                    });
                  }
                  if (offerCriteriaMessages) {
                    $(document).trigger('addToCart.failure', [messages]);
                    generic.overlay.launch({
                      content: offerCriteriaMessages,
                      includeBackground: true,
                      cssStyle: {
                        width: '324px',
                        padding: '25px'
                      }
                    });
                  } else {
                    var resultData = response.getData();
    
                    $(document).trigger('addToCart.success', [resultData]);
                  }
                },
                onError: function () {
                  $addToBag.find('span').text(addToBagText);
                }
              });
            }
          });
        });
      }
    }
  })(jQuery);
  